export default __webpack_public_path__ + "static/media/paper-clip.499e8353.svg";